import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "more-indicator-verbiage more-info-icon" }
const _hoisted_2 = { class: "less-indicator-verbiage more-info-icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("details", {
    class: _normalizeClass(_ctx.detailsCss)
  }, [
    _createElementVNode("summary", {
      class: _normalizeClass(_ctx.linkCss)
    }, [
      _renderSlot(_ctx.$slots, "link", { open: _ctx.open }, () => [
        _renderSlot(_ctx.$slots, "label", {}, () => [
          _cache[0] || (_cache[0] = _createTextVNode("More...", -1))
        ]),
        _createElementVNode("span", _hoisted_1, [
          _renderSlot(_ctx.$slots, "more", {}, () => [
            _cache[1] || (_cache[1] = _createElementVNode("i", { class: "glyphicon glyphicon-chevron-right" }, null, -1))
          ])
        ]),
        _createElementVNode("span", _hoisted_2, [
          _renderSlot(_ctx.$slots, "less", {}, () => [
            _cache[2] || (_cache[2] = _createElementVNode("i", { class: "glyphicon glyphicon-chevron-down" }, null, -1))
          ])
        ])
      ])
    ], 2),
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}